export const PagamentoProcessoModel = {
  pagamento_processo: function () {
    return {
      id: "",
      dt_lancamento: "",
      dt_pgtoideniz: "",
      vl_pgtoindeniz: "",
      processo_id: "",
      st_procTela: "",
      parcelas: []
    }
  },
}

export const ParcelaPagamentoModel = {
  parcela: function () {
    return {
      id: "",
      nr_parcela: "",
      vl_pagamento: "",
      dt_pagamento: "",
      dt_prevista: "",
      vl_previsto: "",
      ds_observacao: "",
      pagamentoProcesso_id: "",
      usuario_id: ""
    }
  },
}


// WEBPACK FOOTER //
// ./src/views/Pagamentos/_model/index.js